/* eslint-disable max-len */
import React, { useCallback } from 'react';
import { useSessionStorage } from 'react-use';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ColorButton } from '../../../ui/ColorButton';
import { KeepPopoutWidgetOpenButton } from '../../../ui/KeepOpenButton';
import { Position } from '../../../ui/Position';
import { useResolve } from '../../Container';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ColorGroup } from './../../../ui';
import { ShapeKind, ShapeStyle } from './ShapeEnums';
import { ShapeSelector } from './ShapeSelector';

export const ShapeWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useResolve(ToolManager);

    const [color, setColor] = useSessionStorage('deqo/ui/shapeWidget/color', ColorGroup.default[3]);
    const [lastStyle, setLastStyle] = useSessionStorage('deqo/ui/shapeWidget/style', ShapeStyle.fillWhite as ShapeStyle);

    const onSelect = useCallback((kind: ShapeKind, sides: number, width: number, height: number, style: ShapeStyle) =>
        (selectMode: 'click' | 'drag') => {
            widget.update({ open: !widget.autoClose });
            setLastStyle(style);
            const mode = selectMode === 'click' ? 'drag' : 'drop';
            tools.setSettings('shapeTool', { kind, style, color, sides, width, height });
            dispatch(toolEquip, ['shapeTool', `${mode}`]);
        },
        [color, tools, dispatch]);

    return <Flexer relative background="white">
        <ShapeSelector
            initialStyle={lastStyle}
            color={color}
            onSelect={onSelect}
        />
        <Position inset=".6" at="topRight">
            <Flexer flex="row" align="center" gap=".5">
                <ColorButton value={color} onChange={setColor} autoSelect groups />
                <KeepPopoutWidgetOpenButton widget={widget} />
            </Flexer>
        </Position>
    </Flexer>;

    // return <Flexer relative background="white" width="24">
    //     <ElementSelector name="shapes" model={model} onSelectItem={onSelect} />
    // <Position inset=".6" at="topRight">
    //     <Flexer flex="row" align="center" gap=".5">
    //         <ColorButton value={color} onChange={setColor} autoSelect groups />
    //         <KeepPopoutWidgetOpenButton widget={widget} />
    //     </Flexer>
    // </Position>
    // </Flexer>;
});
